/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = globalThis, e$1 = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
const S = (s, o) => {
  if (e$1)
    s.adoptedStyleSheets = o.map((t2) => t2 instanceof CSSStyleSheet ? t2 : t2.styleSheet);
  else
    for (const e2 of o) {
      const o2 = document.createElement("style"), n = t.litNonce;
      void 0 !== n && o2.setAttribute("nonce", n), o2.textContent = e2.cssText, s.appendChild(o2);
    }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function e(e2) {
  return class extends e2 {
    createRenderRoot() {
      const e3 = this.constructor, { registry: s, elementDefinitions: n, shadowRootOptions: o } = e3;
      n && !s && (e3.registry = new CustomElementRegistry(), Object.entries(n).forEach(([t2, s2]) => e3.registry.define(t2, s2)));
      const i = this.renderOptions.creationScope = this.attachShadow({ ...o, customElements: e3.registry });
      return S(i, this.constructor.elementStyles), i;
    }
  };
}
export {
  e
};
//# sourceMappingURL=scoped-registry-mixin-2fqf-E5n.js.map
